import React from 'react';
import _ from 'lodash';
import { ReceiptSummary, ReceiptTotalTitle, ReceiptLineSummary } from '../../../components';
import { LanguageCodes } from '../../../types/preference.type';
import { Reservation, Stay, Unit, Guests } from 'guest-data-types-ts-lib';
import { TranslationUtils, CurrencyUtils } from '../../../utils';
import './PalReceiptContent.scss';
import { ReceiptSummaryResponse, ExtendedReceiptSummary } from '../../../services/trip/tripService';

interface ReceiptProps {
    reservation: Reservation;
    guests: Guests;
    stay: Stay;
    receiptSummaryResponse: ReceiptSummaryResponse;
    unit: Unit;
    locale: LanguageCodes;
}

export const PalReceiptContent: React.FC<ReceiptProps> = (props) => {
    const { receiptSummaryResponse, locale, stay } = props;
    const { summary, converted_summary } = receiptSummaryResponse;

    const totalWithSecurityDepositWidget = (widgetSummary: ExtendedReceiptSummary) => {
        const totalText = TranslationUtils.get('total_with_security_deposit_in', { currency: widgetSummary.currency });
        const totalValue = CurrencyUtils.formatCurrency(
            widgetSummary.total + widgetSummary.security_deposit!,
            widgetSummary.currency,
            locale
        );
        return (
            <div data-testid={'add-pet-count-preview'} className={`receipt-total-title without-background compact-receipt-total`}>
                <div>
                    <span className={'body-bold'} tabIndex={0} aria-label={`${totalText} ${totalValue}`}>
                        {totalText}
                    </span>
                </div>
                <div className="receipt-total-title-value">
                    <span className={'body-bold'}>{totalValue}</span>
                </div>
            </div>
        );
    };

    return (
        <div id="receipt-trip">
            <div id="panel-summary" className="col-md-12 cost-breakdown-receipt">
                {/* Summary */}
                <div className="m-3">
                    <ReceiptSummary
                        summary={summary}
                        trip_protection={null}
                        locale={locale}
                        checkInDateTime={stay.check_in_date_time}
                        checkOutDateTime={stay.check_out_date_time}
                    />
                </div>
            </div>

            <div id="panel-totals" className="col-md-12 cost-breakdown-receipt">
                <ReceiptTotalTitle summary={summary} convertedSummary={converted_summary || undefined} locale={locale} />
            </div>
            {summary.security_deposit && (
                <div className="security-deposit-section">
                    <div id="panel-summary" className="col-md-12 cost-breakdown-receipt">
                        <div className="m-3">
                            <div id="items-summary" className="receipt-summary">
                                <ReceiptLineSummary
                                    summaryTitle={`${TranslationUtils.get('security_deposit')}`}
                                    summaryValue={summary.security_deposit}
                                    currency={summary.currency}
                                    locale={locale}
                                />
                            </div>
                        </div>
                    </div>
                    <div id="panel-totals" className="col-md-12 cost-breakdown-receipt">
                        {totalWithSecurityDepositWidget(summary)}
                    </div>
                    {converted_summary?.security_deposit && (
                        <div id="panel-totals" className="col-md-12 cost-breakdown-receipt">
                            {totalWithSecurityDepositWidget(converted_summary)}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
